import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import CardViewer from 'components/field/CardViewer';
import LottiePlayer from 'components/global/LottiePlayer';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { PAYMENT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { setManageSubscriptionReload } from '../../SubscriptionAccount/SubscriptionAccountSlice';
import * as S from './ChangePaymentMethodModal.styled';

export const DeletePaymentMethodModal = NiceModal.create(({ removeCard, onSuccess }) => {
	const axios = useAxiosPrivate();
	const modal = useModal();
	const dispatch = useDispatch();
	const { showError, showSuccess } = useAlert();
	const { t } = useTranslation();

	const [loading, setLoading] = useState(false);

	const deleteClientCard = async (ID) => {
		setLoading(true);
		try {
			const response = await axios.post(PAYMENT.DELETE_CLIENT_CARD, {
				clientCardID: ID
			});
			if (response.status === 200) {
				showSuccess();
				modal.remove();
				dispatch(setManageSubscriptionReload(true));
			} else {
				AppLogger.error(response);
			}
			onSuccess?.();
		} catch (error) {
			if (error.response?.data.code === 'error.P028') {
				showError({
					message: 'deleteCardActiveShipmentsError'
				});
			} else {
				AppLogger.error(error);
				showError();
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal fullwidth maxWidth="small" className="modal-deletePaymentMethod">
			<ModalTitle>
				<Typography variant="p1">deletePaymentMethod</Typography>
			</ModalTitle>

			<ModalContent className="mt-5 mb-5" style={{ alignSelf: 'center' }}>
				<S.DeleteLottieContainer>
					<LottiePlayer name="confirmation-modal" width="100px" height="100px" />

					<Typography variant="p1" fontWeight="500" className="mb-3 mt-3">
						deletePaymentMethod
					</Typography>
				</S.DeleteLottieContainer>

				<S.DeleteLottieSubtitle>
					<CardViewer lastFour={removeCard?.cardLastFour} cardBrand={removeCard?.cardBrand} />
					<Typography fontWeight="500" color="var(--content-3)">
						{t('areYouSureYouWantToDelete')}{' '}
					</Typography>
				</S.DeleteLottieSubtitle>
			</ModalContent>

			<ModalActions>
				<Button variant="outline" label="cancel" onClick={() => modal.remove()} />

				<Button
					label="deletePaymentMethod"
					color="var(--red-70)"
					loading={loading}
					onClick={() => deleteClientCard(removeCard.ID)}
				/>
			</ModalActions>
		</Modal>
	);
});
export default DeletePaymentMethodModal;
